import type { UseMutationResult } from "@tanstack/react-query";

import { mbcAdminKeys } from "@/hooks/queryKeys";

import type { InputOf } from "../../useMbcAdminMutation";

import { useMbcAdminMutation } from "../../useMbcAdminMutation";
import { setDesignTypeMbc } from "../api";

export function useSetDesignTypeMbc(): UseMutationResult<
  void,
  Error,
  InputOf<typeof setDesignTypeMbc>
> {
  return useMbcAdminMutation(setDesignTypeMbc, mbcAdminKeys.catalog());
}
